/**
 * List of API URL patterns for which the loading bar will NOT be shown.
 *
 * Add any polling, background-fetch, or silent API endpoints here.
 * Each entry is a substring match against request url (case-insensitive).
 */
const LOADING_BAR_EXCLUDE_URLS = [
  "/livekit/room/board/",
  "/BoardForm/getFormAttentionSummary/",
  "/board/getMyMissingDailyReportsAcrossBoards",
  "/user/human-in-loop/pending",
  "/user/getUserNotifications",
  "/tool/speech-to-text/history",
  "/human-in-loop",
  "WorikingTimeUser",
  "smart-dashboard",
  "/get-started/generation/",
  "bookReader/books/",
  "/ai-team-runs",
  "/AI/copilot/chats/",
  "/AI/browser-use/tasks/",
  "/agent-runtime/jobs"
];

function shouldSkipLoadingBar(url) {
  if (!url) return false;
  const u = String(url).toLowerCase();
  return LOADING_BAR_EXCLUDE_URLS.some((pattern) =>
    u.includes(pattern.toLowerCase()),
  );
}

export { LOADING_BAR_EXCLUDE_URLS, shouldSkipLoadingBar };
